var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('McButton',{attrs:{"variant":"secondary","text":"Lihat Template","icon":"icon-outline_external-link","iconPosition":"right","size":"sm"},on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }